import { ICardDelivery, ICardDeliveryTabPrimary } from "./types"

import { CardDeliveryTabLogs } from "./ui.tab.logs"
import { CardDeliveryTabPrimary } from "./ui.tab.primary"

import { IconClearClose, IconLogs, IconMainGrid } from "@img/icons"
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'
import { Flex, Loader, Drawer, Divider, Button, Tab } from "@ui/index"

import css from './ui.module.scss'


/** Анкета доставки */
export const CardDelivery = ({
    isOpen, isLoadingCard, isDisableBtnSave, tabActive, loadingTitle, fieldsError, dataBase, contractNumber, contractDate, applicationID,
    txtDeliveryToWhom, txtDeliveryAddress, txtIsAddressConfirmed, txtComment,
    listFiles, listListeners, listTrackNumbers, listLogs, txtIsDeliveryCDEK,
    handlerOpenModalConfirm, handlerOpenModalPreview, handlerDownloadFiles, 
    handlerSendingTrackNumbers, handlerSendingListenerFiles, handlerFileUploader,
    handlerOpenModalTrackNumber, handleBtnSave, handleBtnClose, handleOpenModalSendPayment
}: ICardDelivery) => {
    const siteLogo = dataBase === 'yaskill'
        ? {src: logoYaSkill, name: 'YaSkill'}
        : dataBase === 'modern_academy'
            ? {src: logoModSkill, name: 'ModSkill'}
            : null

    /** Свойства передаваемые в основную вкладку */
    const propsToCardDeliveryTabPrimary: ICardDeliveryTabPrimary = {
        fieldsError,
        txtDeliveryToWhom, txtDeliveryAddress, txtIsAddressConfirmed, txtComment,
        listFiles, listListeners, listTrackNumbers, txtIsDeliveryCDEK,
        handlerOpenModalPreview, handlerDownloadFiles, handlerSendingTrackNumbers, 
        handlerSendingListenerFiles, handlerFileUploader, handlerOpenModalTrackNumber
    }

    /** Отображение страницы в зависимости от выбора активной вкладки */
    const getCardPage = (tabActive: string) => {
        switch (tabActive) {
            case 'primary': return <CardDeliveryTabPrimary {...propsToCardDeliveryTabPrimary} />
            case 'logs': return <CardDeliveryTabLogs logsList={listLogs} />
        }
    }
    
    /** Функция по получению кнопочной панели в низу анкеты, в зависимости от выбранной вкладки */
    const getCardPageBtnPanel = (tabActive: string) => {
        switch (tabActive) {
            case 'primary': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexDirection='row' gap='4px' justifyContent='flex-start'>
                        <Flex flexDirection='row' gap='4px'>
                            <Button variant='primaryDark' padding='0 10px' onClick={() => handlerOpenModalConfirm(true, 'Закрытие договора', 'Вы действительно хотите закрыть данный договор?', 'sendingOrCloseContract')}>
                                Закрыть договор
                            </Button>

                            <Divider type='vertical' margin='8px' />

                            <Button variant='iconBorder' padding='0 10px' onClick={() => handleOpenModalSendPayment(true)}>
                                Счёт
                            </Button>

                            <Button variant='iconBorder' padding='0 10px' onClick={() => handlerOpenModalConfirm(true, 'Отправка заявления', 'Вы действительно хотите отправить заявление на доставку?', 'sendingApplicationDeliveryToClient')}>
                                Заявление
                            </Button>

                            <Divider type='vertical' margin='8px' />
                        </Flex>

                        <Flex flexDirection='row' gap='4px' className='mobile550'>
                            <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handleBtnSave(true)}>Сохранить и закрыть</Button>
                            <Button padding='0 10px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handleBtnSave(false)}>Сохранить</Button>
                        </Flex>
                    </Flex>
                </Flex>
            }

            case 'logs': return ''
        }
    }

    return <Drawer isOpen={isOpen} placement='bottom' size='99.4%'>
        <Flex className='drawer_container'>
            <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                <header>
                    <Flex gap='4px' flexDirection='row' alignItems='center'>
                        {siteLogo && <img className={css['header_logo']} src={siteLogo.src} alt={`Логотип ${siteLogo.name}`} />}
                        <h4>Анкета доставки</h4>
                    </Flex>

                    <h5>№ {contractNumber.value} от {contractDate.value} (👉 {applicationID.value})</h5>
                </header>

                <Button id='tooltipBtnClose' variant='icon' size='md' isDisabled={isLoadingCard} onClick={handleBtnClose}>
                    <IconClearClose />
                </Button>
            </Flex>

            <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                <Flex gap='6px' className='drawer_container-content' overflowY={['files', 'listeners'].includes(tabActive.value) ? 'hidden' : 'scroll'} padding={['files', 'listeners'].includes(tabActive.value) ? '2px 0px 0px 0px' : '4px 8px 4px 4px'}>
                    {getCardPage(tabActive.value)}
                </Flex>

                {getCardPageBtnPanel(tabActive.value)}
            </Flex>

            <Tab.Container>
                <Tab.Item tabName='primary' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Основные данные' onClick={tabActive.setValue}><IconMainGrid /></Tab.Item>
                <Tab.Item tabName='logs' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Журнал изменений' onClick={tabActive.setValue}><IconLogs /></Tab.Item>
            </Tab.Container>

            <Loader isOpen={isLoadingCard} title={loadingTitle.value} backdrop />
        </Flex>
    </Drawer>
}